import React from "react";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#000000] py-16 md:py-24 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 md:px-12 lg:px-16">
        <Reveal className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-fuchsia-500" />
            <span className="text-[10px] uppercase tracking-[0.32em] text-fuchsia-400 font-bold">
              About Us · 100% Growth Focused
            </span>
            <span className="h-px w-10 bg-fuchsia-500" />
          </div>
          <h2
            data-testid="about-headline"
            className="font-display text-3xl sm:text-4xl lg:text-5xl xl:text-[64px] font-black tracking-[-0.03em] text-white leading-[0.98] max-w-5xl mx-auto"
          >
            We architect the{" "}
            <span className="text-white/40 italic font-light">end-to-end</span>{" "}
            marketing ecosystems brands grow inside of.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <Reveal
            variant="left"
            className="lg:col-span-5 relative order-2 lg:order-1"
            delay={80}
          >
            <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
              <img
                src="https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
                alt="Strategy session"
                className="w-full h-full object-cover grayscale-[40%] contrast-[1.05] transition-transform duration-[1800ms] ease-out hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#000000] via-[#000000]/30 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-[10px] uppercase tracking-[0.3em] text-fuchsia-400 font-bold mb-2">
                    Est. 2023
                  </div>
                  <div className="font-display text-xl md:text-2xl font-bold text-white">
                    Strategy meets <br /> storytelling.
                  </div>
                </div>
                <div className="bg-fuchsia-500 text-white w-16 h-16 shrink-0 flex flex-col items-center justify-center">
                  <span className="font-display text-xl font-black leading-none">
                    100%
                  </span>
                  <span className="text-[8px] tracking-widest uppercase mt-1">
                    Growth
                  </span>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal
            variant="right"
            className="lg:col-span-7 order-1 lg:order-2"
            delay={160}
          >
            <div className="space-y-5 text-white/65 leading-relaxed font-body text-sm md:text-[15px]">
              <p data-testid="about-paragraph-1">
                1902 Enterprises is a full-service advertising, marketing and
                growth consultancy designed for today&apos;s dynamic,
                performance-led business environment. We integrate strategic
                thinking, creative excellence, performance marketing, video
                production, sponsorship and partnerships, and operational
                rigour to deliver sustainable and scalable brand growth.
              </p>
              <p data-testid="about-paragraph-2">
                We collaborate with startups, D2C brands, corporates and
                established enterprises to architect and execute end-to-end
                marketing ecosystems that build brand equity, drive demand, and
                generate measurable business outcomes.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
